"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateIndustryCommand model module.
 * @module model/CreateIndustryCommand
 * @version 1.1.3-alpha.1
 */
class CreateIndustryCommand {
  /**
   * Constructs a new <code>CreateIndustryCommand</code>.
   * @alias module:model/CreateIndustryCommand
   * @param title {String} 
   */
  constructor(title) {
    CreateIndustryCommand.initialize(this, title);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, title) {
    obj['title'] = title;
  }

  /**
   * Constructs a <code>CreateIndustryCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateIndustryCommand} obj Optional instance to populate.
   * @return {module:model/CreateIndustryCommand} The populated <code>CreateIndustryCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateIndustryCommand();
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('parent_id')) {
        obj['parent_id'] = _ApiClient.default.convertToType(data['parent_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateIndustryCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateIndustryCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CreateIndustryCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    // ensure the json data is a string
    if (data['parent_id'] && !(typeof data['parent_id'] === 'string' || data['parent_id'] instanceof String)) {
      throw new Error("Expected the field `parent_id` to be a primitive type in the JSON string but got " + data['parent_id']);
    }
    return true;
  }
}
CreateIndustryCommand.RequiredProperties = ["title"];

/**
 * @member {String} title
 */
CreateIndustryCommand.prototype['title'] = undefined;

/**
 * @member {String} description
 */
CreateIndustryCommand.prototype['description'] = undefined;

/**
 * @member {String} parent_id
 */
CreateIndustryCommand.prototype['parent_id'] = undefined;
var _default = exports.default = CreateIndustryCommand;